export default {
  // Common
  common: {
    app_code: 'dmp',
    collectedEvents: 'Collected Events',
    resetView: 'Reset view',
    app_name: 'Higashikawa Tourism DX',
    env_prod: '',
    env_prod_mobile: '',
    env_test: '【Test environment】',
    env_local: '【Local environment】',
    env_test_mobile: '[Test]',
    env_local_mobile: '[Local]',
    loading: 'Loading...',
    logout: 'Logout',
    admin: 'Admin',
    users: 'Users',
    userRegistrationRequests: 'User Registration Requests',
    dataProviders: 'Data Providers',
    masterData: 'Master Data',
    postalCodes: 'Postal Codes Master',
    systemLogs: 'System Logs',
    language: 'Language Settings',
    changeLanguage: 'Change Language',
    copyright: 'Copyright (C) Higashikawa Tourism DX Consortium',
    errorGeneral: 'An error occurred. Please try again.',
    notSet: 'Not set',
    contact: 'Contact',
    calendar: {
      weekdays: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
      },
    },
    error_dialog: {
      default_title: 'Error',
      ok: 'OK'
    },
    info_dialog: {
      default_title: 'Information',
      ok: 'OK'
    },
    warning_dialog: {
      default_title: 'Warning',
      ok: 'OK'
    },
    confirm_dialog: {
      default_title: 'Confirmation',
      ok: 'OK',
      cancel: 'Cancel'
    },
  },

  // Header
  header: {
    welcomeMessage: 'Hello, ',
    nameTitle: ''
  },

  // Side Menu
  sideMenues: {
    home: 'Home',
    events: 'Events',
    accommodationBookings: 'Accommodation',
    import: 'Import',
    export: 'Export',
    masterData: 'Master Data',
    dataManagement: 'Data Management',
    donatorInformation: 'Donator Information',
    statisticData: 'Statistics',
    eventOrganizers: 'Event Organizers',
  },

  // Pagination
  pagination: {
    itemsPerPage: 'Items per page',
    itemsCount: '{count}',
    showing: 'Showing {from} - {to} of {total} entries',
    page: 'Page',
    totalPages: '/ {total}',
    no_records: 'No matching records found.',
    per_page: {
      '25': 'Show 25',
      '50': 'Show 50',
      '100': 'Show 100'
    }
  },

  // HTTP status error messages
  httpStatusMessages: {
    httpStatusTitle403: 'Access Denied',
    httpStatusMsg403: 'You do not have permission to view this page.\nYou either lack the required permissions or access is restricted.',
    httpStatusTitle404: 'Page Not Found',
    httpStatusMsg404: 'The page does not exist or the URL is incorrect.',
    httpStatusTitle500: 'Server Error',
    httpStatusMsg500: 'A server error has occurred.\nPlease wait a moment and try again.'
  },

  // Validation messages
  validation: {
    required: {
      currentPassword: 'Please enter your current password.',
      newPassword: 'Please enter a new password.',
      confirmPassword: 'Please confirm your new password.'
    },
    minLength: 'The new password must be at least 8 characters long.',
    mismatch: 'The new password and confirmation password do not match.',
    error: 'Failed to change password.',
    password: {
      minLength: 'Password must be at least 8 characters long.',
      invalidCharacters: 'Password must be at least 8 characters and include uppercase letters, lowercase letters, numbers, and symbols (! . - _)',
      sameAsCurrentPassword: 'New password cannot be the same as current password.'
    }
  },

  // Password change related
  password: {
    change: 'Change Password',
    current: 'Current Password',
    new: 'New Password',
    confirm: 'Confirm New Password',
    button: 'Change Password',
    cancel: 'Cancel',
    minLength: 'Please enter at least 8 characters',
    success: 'Password has been changed successfully.',
    failed: 'Failed to change password.'
  },

  // Email change
  email: {
    change: 'Change Email Address',
    current: 'Current Email Address',
    new: 'New Email Address',
    button: 'Change Email Address',
    cancel: 'Cancel',
    success: 'Email change request has been sent. A confirmation email has been sent to your new email address.',
    failed: 'Failed to change email address.',
    confirmSuccess: 'Email address has been changed successfully.',
    confirmFailed: 'Failed to confirm email change.',
    complete: {
      title: 'Email Address Changed',
      message: 'Your email address has been successfully changed. Please log in with your new email address.',
      loginButton: 'Go to Login',
      processing: 'Processing...',
      errorTitle: 'An Error Occurred',
      invalidToken: 'Invalid token.',
      tokenNotFound: 'Token not found.',
      tokenExpired: 'Token has expired.',
      failed: 'Failed to change email address.'
    },
    validation: {
      currentEmailRequired: 'Please enter your current email address.',
      currentEmailInvalid: 'The current email address format is invalid.',
      newEmailRequired: 'Please enter your new email address.',
      newEmailInvalid: 'The new email address format is invalid.',
      sameEmail: 'The new email address cannot be the same as your current email address.'
    }
  },

  // Legal pages
  legal: {
    titleTermsOfUse: 'Terms of Use',
    titlePrivacyPolicy: 'Privacy Policy',
    titleExternalTools: 'External Tool Disclosure',
  },

  // Authentication pages
  auth: {
    // Login page
    login: {
      title: 'Login',
      subtitle: 'User Portal',
      subtitle_admin: 'System Admin Portal',
      email: 'Email Address',
      password: 'Password',
      remember: 'Keep me logged in',
      submit: 'Login',
      signupLink: 'Sign up here',
      forgotPasswordLink: 'Forgot your password?',
      forNewUserTitle: 'For new users',
      forNewUserDescription: 'Using Higashikawa Tourism DX requires a registration application. You will be able to log in once your application has been approved.',
      validation: {
        emailRequired: 'Please enter your email address.',
        emailInvalid: 'Please enter a valid email address.',
        passwordRequired: 'Please enter your password.'
      },
      error: {
        invalid_credentials: 'Invalid email or password.',
        failed: 'Login failed.'
      }
    },

    // Admin Login page
    adminLogin: {
      title: 'DMP Admin Web',
      email: 'Email Address',
      password: 'Password',
      remember: 'Keep me logged in',
      submit: 'Login',
      authOidc: 'Microsoft Entra ID Authentication',
      emailLoginNotice: 'Sign in with email address',
      forgotPasswordLink: 'Forgot your password?',
      error: {
        failed: 'Microsoft Entra ID login failed.'
      }
    },

    activate_success: 'Account activation completed.',
    logout_success: 'You have been logged out.',

    // Signup page
    signup: {
      title: 'User Registration Request',
      description: 'Using "Higashikawa Tourism DX" requires a registration application. You will be able to log in once approval is complete.',
      name: 'Name',
      email: 'Email Address',
      officeName: 'Facility Name',
      postalCode: 'Postal Code',
      address: 'Address',
      phoneNumber: 'Phone Number',
      organization: 'Organization',
      selectOrganization: 'Please select an organization',
      organizations: {
        noOrganization: 'No Organization',
        tourAssociate: 'Higashikawa Tourism Association',
        chamberCommerce: 'Higashikawa Chamber of Commerce'
      },
      submit: 'Confirm',
      confirmTitle: 'Confirm Your Information',
      confirmDescription: 'Please review the information below. If everything is correct, click the "Submit" button.',
      register: 'Submit',
      back: 'Back To Modify',
      loginLink: 'Login here',
      successTitle: 'Application received',
      successMessage: 'The application has been received. After approval, you will receive an email with instructions for registration',
      backToLogin: 'Back to Login',
      validation: {
        nameRequired: 'Please enter your name.',
        nameMaxLength: 'Name must be 255 characters or less.',
        emailRequired: 'Please enter your email address.',
        emailInvalid: 'Please enter a valid email address.',
        emailMaxLength: 'Email address must be 255 characters or less.',
        officeNameRequired: 'Please enter the facility name.',
        officeNameMaxLength: 'Facility name must be 255 characters or less.',
        postalCodeRequired: 'Please enter the postal code.',
        postalCodeInvalid: 'Please enter postal code in format "999-9999".',
        addressRequired: 'Please enter the address.',
        addressMaxLength: 'Address must be 255 characters or less.',
        phoneNumberRequired: 'Please enter the phone number.',
        phoneNumberInvalid: 'The phone number can only contain the ' + ' symbol (half-width) and half-width digits, up to a maximum of 15 characters.',
        organizationRequired: 'Please select an organization.'
      },
      agreePrefix: 'I agree to the ',
      agreeConjunction: ' and ',
      agreeSuffix: ''
    },

    // Activate page
    activate: {
      title: 'Complete Registration',
      description: 'Password must be at least 8 characters and include uppercase letters, lowercase letters, numbers, and symbols (! . - _)',
      password: 'Password',
      passwordConfirm: 'Confirm Password',
      submit: 'Register',
      loading: 'Loading user information...',
      successTitle: 'Registration Complete',
      successMessage: 'Your user registration is complete.',
      goHome: 'Go to Home',
      errorTitle: 'An Error Occurred',
      backToLogin: 'Back to Login',
      invalidToken: 'Invalid link. Authentication token not found.',
      tokenExpired: 'Token is invalid or has already been used.',
      userNotFound: 'Failed to retrieve user information.',
      activationFailed: 'Registration completion failed.',
      validation: {
        passwordRequired: 'Please enter a password.',
        passwordMinLength: 'Password must be at least 8 characters long.',
        passwordConfirmRequired: 'Please confirm your password.',
        passwordMismatch: 'Passwords do not match.'
      }
    },

    // Forgot password page
    forgotPassword: {
      title: 'Reset Password',
      description1: 'Please enter your registered email address.',
      description2: 'We will send you an email to reset your password.',
      email: 'Email Address',
      submit: 'Send Confirmation Email',
      backToLogin: 'Back',
      success: 'We have sent a password reset email. Please check your email.',
      failed: 'Failed to send email. Please wait a moment and try again.',
      confirmTitle: 'Please Check Your Email',
      confirmDescription1: 'An email has been sent to ',
      confirmDescription2: 'Please reset your password using the URL provided in the email.',
      validation: {
        emailRequired: 'Please enter your email address.',
        emailInvalid: 'Please enter a valid email address.'
      }
    },

    // Reset password page
    resetPassword: {
      title: 'Reset Password',
      description1: 'Please enter your new password.',
      description2: '* Password must be at least 8 characters and include uppercase letters, lowercase letters, numbers, and symbols (! . - _)',
      email: 'Email Address',
      password: 'New Password',
      passwordConfirm: 'Confirm New Password',
      submit: 'Reset Password',
      backToLogin: 'Back to Login',
      success: 'Your password has been reset successfully.',
      failed: 'Failed to reset password.',
      validation: {
        emailRequired: 'Please enter your email address.',
        emailInvalid: 'Please enter a valid email address.',
        passwordRequired: 'Please enter your password.',
        passwordMinLength: 'Password must be at least 8 characters.',
        passwordConfirmRequired: 'Please confirm your password.',
        passwordMismatch: 'Passwords do not match.',
        sameAsCurrentPassword: 'New password cannot be the same as current password.'
      }
    }
  },

  // Data Providers (Laravel translation structure)
  // API Call Histories
  api_call_histories: {
    title: 'Public API Calls',
    note: '* Call counts and status codes are aggregated per source system. Request and response bodies are not shown.',
    days: 'Last {days} days',
    data_provider: 'Source',
    endpoint: 'Endpoint',
    method: 'Method',
    status_code: 'Status',
    calls: 'Calls',
    first_called_at: 'First call',
    last_called_at: 'Last call',
    empty: 'No calls were recorded in this period.',
    failures_title: 'Breakdown of failed calls',
    failures_note: '* Only the names of the rejected fields are shown. The submitted values are not shown.',
    message: 'Message',
    rejected_fields: 'Rejected fields',
    value_types_title: 'Types of the rejected values',
    value_types_note: '* Aggregated from the 5 most recent failures. Only the type of each rejected value is read, never the value itself.',
    value_type: 'Type',
    occurrences: 'Occurrences',
  },

  data_providers: {
    title: 'Data Providers',
    name: 'Name',
    status: 'Status',
    description: 'Description',
    register: 'Register',
    edit: 'Edit',
    delete: 'Delete',
    details: 'Details',

    // Status
    status_values: {
      active: 'Active',
      inactive: 'Inactive'
    },

    // Form
    form: {
      title: 'Register Data Provider',
      edit_title: 'Edit Data Provider',
      name_label: 'Name',
      status_label: 'Status',
      status_placeholder: 'Please select a status',
      description_label: 'Description',
      register_button: 'Register',
      update_button: 'Update',
      cancel: 'Cancel',
      create_note: 'Token management will be available in the detail screen after creation.'
    },

    // Messages
    messages: {
      created: 'Data provider "{name}" has been registered.',
      updated: 'Data provider "{name}" has been updated.',
      deleted: 'Data provider "{name}" has been deleted.',
      confirm_delete: 'Are you sure you want to delete this?'
    }
  },

  // Token Management
  tokens: {
    title: 'Token Management',
    generate_token: 'Generate Token',
    personal_access_tokens: 'Personal Access Tokens',
    name: 'Name',
    token_value: 'Token Value',
    abilities: 'Abilities',
    expires_at: 'Expires At',
    created_at: 'Created At',
    actions: 'Actions',
    delete: 'Delete',
    copy_token: 'Copy Token',
    token_not_shown_after_creation: '(Token not shown after creation)',
    never_expires: 'Never expires',
    no_tokens: 'No tokens found.',

    // Messages
    messages: {
      token_generated: 'Token generated successfully.',
      token_deleted: 'Token deleted successfully.',
      token_copied: 'Token copied to clipboard.',
      copy_failed: 'Failed to copy token to clipboard.',
      confirm_delete_token: 'Are you sure you want to delete this token?',
      enter_token_name: 'Enter a name for this token:',
      max_tokens_reached: 'Cannot create more than 10 tokens per data provider.'
    }
  },

  // Dashboard related
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Daily tracking of hotel bookings, event bookings, visitor trends, and more',
    tooltip: '選択中期間の宿泊予約またはイベント予約をしている訪問者数を集計',

    // Time periods
    periods: {
      yesterday: 'Yesterday',
      today: 'Today',
      tomorrow: 'Tomorrow'
    },

    // Statistics labels
    stats: {
      hotelBookings: 'Hotel Bookings',
      eventBookings: 'Event Bookings',
      eventsCount: 'Events',
      hotelBookingsDesc: 'Number of bookings, not number of guests',
      eventBookingsDesc: 'Number of bookings, not number of event participants',
      eventsCountDesc: 'Yesterday: actual count, today/tomorrow: scheduled count'
    },

    // Chart
    chart: {
      title: 'Visitor Trends',
      subtitle: 'Scheduled and Actual',
      thisYearVisitors: '',
      lastYearVisitors: '',
      period: {
        oneWeek: '1 Week',
        oneMonth: '1 Month',
        threeMonths: '3 Months'
      }
    },

    // Summary stats
    summary: {
      totalHotelBookings: 'Total Hotel Bookings',
      totalEventBookings: 'Total Event Bookings',
      totalEvents: 'Total Events',
      avgDailyVisitors: 'Avg Daily Visitors',
      periods: {
        threeDayTotal: 'Recent 3-day scheduled count (today is included)',
        thirtyDayAverage: 'Past 30-day average'
      }
    },

    // Home page
    home: {
      title: 'Home',
    },

    // Visitor Card
    visitor: {
      title: 'Number of Visitors',
      person_unit: 'people',
      year_label: '{year}',
      selected_period_label: 'Selected Period',
      previous_year_same_period_label: 'Previous Year Same Period',
    },

    // Daily Visitor Card
    daily_visitor: {
      residential_area: 'Residential Area',
      visitor: 'Visitors',
      others: 'Others',
      unanswered: 'Unanswered',
      no_data: 'No Data',
    },

    // Date Range Picker
    date_range: {
      cancel: 'Cancel',
      apply: 'Apply',
      alert: {
        max_range: 'You can select a maximum period of 14 days.',
        select_dates: 'Please select both start and end dates.',
      },
    },

    // Repeat Visitors & Higashikawa Shareholder
    stats: {
      title_repeat_visitors: 'Repeat Visitors',
      title_higashikawa_stockholder_visitors: 'Higashikawa Shareholders',
      number_unit: '%',
      trend_up: '↑',
      trend_down: '↓',
      trend_na: '± N/A (No previous year data)',
    },

    // Demographics
    demographics: {
      title_age_group: 'Age Group',
      title_gender: 'Gender',
      age_group_less_20: '20 <',
      age_group_20: '20 < 30',
      age_group_30: '30 < 40',
      age_group_40: '40 < 50',
      age_group_50: '50 < 60',
      age_group_more_60: '60 <',
      age_group_unknown: 'Unknown',
      gender_male: 'Male',
      gender_female: 'Female',
      gender_unknown: 'Unknown',
    },

    // Occupancy Card
    occupancy: {
      title: 'Accommodation Occupancy Rate',
      subtitle: 'Number of reservations booked via tomarin',
      detail_link: 'Accommodation reservation details',
      occupancy_rate: 'Occupancy Rate',
      total_rooms: 'Total Rooms',
      booked_rooms: 'Booked Rooms',
      rooms_unit: ' rooms',
      additional_note: '* Displays the ratio of rooms booked through tomarin to the total number of rooms × number of days in the selected period.',
      booked_rooms_label: 'Booked',
      available_rooms_label: 'Available',
    },

    // Crowd Level Calendar Card
    crowdLevelCalendar: {
      title: 'Event Implementation Status',
      legend: {
        crowded: '100+ people',
        crowdedBit: '50-99 people',
        crowdedModerate: '1-49 people',
        crowdedNone: '0 people',
      },
      modal: {
        title: 'Event Implementation Status Details',
        date: 'Date',
        totalEvents: 'Total Events',
        eventCapacities: 'Event Capacities',
        eventParticipants: 'Event Participants',
        forecastedEventParticipants: 'Forecasted Event Participants',
        unit: '',
        peopleUnit: ' people',
      },
    },

    // Events Combined Card
    events: {
      reservation_title: 'Event Reservations',
      reservation_subtitle: 'Events held and reservations',
      event_reservation_label: 'Event Reservations',
      user_attributes: 'User Attributes',
      shareholder: 'Higashikawa Shareholders',
      repeater: 'Repeat Visitors',
      repeater_only: 'Repeat Visitors Only',
      stockholder_only: 'Shareholders Only',
      both: 'Both Repeat & Shareholder',
      other: 'Other',
      total: 'Total',
      peopleUnit: ' people',
      booked_label: 'Booked',
      available_label: 'Available',
      total_capacity: 'Total events: {count} people',
      top_events: 'Top Events',
      table: {
        event_name: 'Event Name',
        capacity: 'Capacity',
        online: 'Online',
        organizer: 'Organizer',
        date: 'Date',
      },
      event_list_link: 'List of all events',
      no_data: 'No Data',
    },

    tooltips: {
      visitorCard: 'This card shows the total of guests who have either of accommodation bookings and event bookings in the selected period.',
      repeatVisitorCard: 'This shows the percentage of repeat visitors during the selected period. The rate of change represents the comparison with the same period last year. Since visitors are counted individually during the period, the total number may not match the visitor trend graph.',
      higashikawaStockholderVisitorCard: 'This shows the percentage of higashikawa stockholder visitors during the selected period. The rate of change represents the comparison with the same period last year. Since visitors are counted individually during the period, the total number may not match the visitor trend graph.',
      ageGroupChartCard: 'Aggregates visitors during the selected period by age group (excluding no responses). Due to different aggregation methods, the total number may not match the visitor trend graph.',
      genderChartCard: 'Aggregates visitors during the selected period by gender (excluding no responses). Due to different aggregation methods, the total number may not match the visitor trend graph.',
      occupancyCard: 'Displays the ratio of rooms booked through tomarin to the total number of rooms × number of days in the selected period.',
      crowdLevelCalendarCard: 'The calendar is color-coded based on the number of event participants in the month to which the start date of the selected period belongs. Note that online events are not displayed on the calendar.',
      topEvents: 'The top five events with the highest capacity are displayed among the events scheduled for the period selected on the calendar.',
    },

    // Repeat Visitor Detail Modal
    repeatVisitorDetail: {
      selectedPeriod: 'Selected Period',
      previousYearPeriod: 'Previous Year Period',
      changeRate: 'Rate of Change',
      repeatVisitors: 'Repeat Visitors: ',
      total: 'Total: ',
      personUnit: ' people',
      additionalNote: '* Since visitors are counted individually during the period, the total number may not match the visitor trend graph.',
    },

    // Higashikawa Stockholder Visitor Detail Modal
    higashikawaStockholderVisitorDetail: {
      selectedPeriod: 'Selected Period',
      previousYearPeriod: 'Previous Year Period',
      changeRate: 'Rate of Change',
      higashikawaStockholderVisitors: 'Stockholder Visitors: ',
      total: 'Total: ',
      personUnit: ' people',
      additionalNote: '* Since visitors are counted individually during the period, the total number may not match the visitor trend graph.',
    },

    // Age Group Visitor Detail Modal
    ageGroupVisitorDetail: {
      additionalNote: '* Since visitors are counted individually during the period, the total number may not match the visitor trend graph.',
      peopleUnit: ' people',
    },

    // Gender Visitor Detail Modal
    genderVisitorDetail: {
      additionalNote: '* Since visitors are counted individually during the period, the total number may not match the visitor trend graph.',
      peopleUnit: ' people',
    },
  },

  // Master Data
  guestDemographics: {
    age_less_20: '-20',
    age_20: '20-30',
    age_30: '30-40',
    age_40: '40-50',
    age_50: '50-60',
    age_more_60: '60+',
    age_other: 'Other',
    male: 'Male',
    female: 'Female',
    no_answer: 'No Answer',
  },
  eventDetail: {
    edit: 'Edit',
    eventDate: 'Event Date',
    fee: 'Fee',
    capacity: 'Capacity',
    peopleUnit: '',
    currencyUnit: ' JPY',
    dateFormat: '{year}/{month}/{day}',
    bookingRate: 'Bookings',
    accommodationGuests: 'Staying in Town',
    repeaters: 'Returning Visitors',
    stockholders: 'Higashikawa Stockholders',
    ageGroups: 'Age Groups',
    genders: 'Gender',
    genderNoAnswer: 'No Answer',
    residentialAreas: 'Residential Areas',
    distributionComparison: 'Distribution Comparison',
    participants: 'Participants',
    allEvents: 'All Events',
    showMore: 'Show more',
    showLess: 'Show less',
    noData: 'No data available',
    loading: 'Loading...',
    notFound: 'Event not found',
  },
  accommodationSummary: {
    title: 'Accommodations',
    bookings: 'Bookings',
    bookingsSubtitle: 'Booking trend via tomarin',
    help: 'Shows accommodation booking data for the selected period, as of the last daily aggregation.',
    resetView: 'Reset view',
    peopleUnit: '',
    selectedPeriod: 'Selected period',
    previousYearPeriod: 'Same period last year',
    occupancy: 'Room Occupancy',
    repeaters: 'Returning Guests',
    stockholders: 'Higashikawa Stockholders',
    ageGroups: 'Age Groups',
    genders: 'Gender',
    genderNoAnswer: 'No Answer',
    residentialAreas: 'Residential Areas',
    noData: 'No data available',
  },
  collectedEvents: {
    tabSources: 'Sources',
    sourceUrl: 'URL',
    sourceMethod: 'Method',
    sourceTotal: 'Total Collected',
    sourceLastRun: 'Last Run',
    sourceNeverRun: 'Never run',
    sourceOk: 'Success',
    sourceFailed: 'Failed',
    category: 'Category',
    collectNow: 'Collect now',
    collectErrors: 'Failed sources',
    collectFailed: 'Collection failed.',
    title: 'Collected Events',
    description: 'Event candidates crawled every morning from the town websites. Review each one and register it, or mark it as not applicable. Registered events are created as drafts.',
    source: 'Source',
    eventTitle: 'Event Name',
    period: 'Date',
    venue: 'Venue',
    actions: 'Actions',
    approve: 'Register',
    reject: 'Dismiss',
    approveTitle: 'Register as an Event',
    approveNote: 'The collected content is extracted automatically and may contain mistakes. Please review and correct it before registering.',
    approveSubmit: 'Register',
    approveFailed: 'Registration failed.',
    cancel: 'Cancel',
    startDate: 'Start Date',
    endDate: 'End Date',
    capacity: 'Capacity',
    feeAmount: 'Fee (JPY)',
    feeSource: 'As collected',
    descriptionLabel: 'Description',
    statusPending: 'Pending',
    statusApproved: 'Registered',
    statusRejected: 'Dismissed',
    loading: 'Loading...',
    empty: 'No matching events',
  },
  adminDashboard: {
    pendingRequests: 'Pending User Registration Requests',
    errors24h: 'Errors in the Last 24 Hours',
    countUnit: '',
    errorsBreakdown: 'Public API: {api} / Operations: {operation}',
    providersTitle: 'Data Provider Activity',
    providerName: 'Provider Name',
    lastCalledAt: 'Last Received',
    calls24h: 'Calls (24h)',
    providerErrors24h: 'Errors (24h)',
    neverCalled: 'Never received',
    noProviders: 'No data providers found',
    tablesTitle: 'Key Data Counts',
    loading: 'Loading...',
  },
  masterData: {
    title: 'Master Data List',
    detailTitle: 'Master Data Detail',
    tableNameHeader: 'Table Name',
    rowCountHeader: 'Rows',
    lastUpdatedHeader: 'Last Updated',
    loading: 'Loading...',
    noTablesFound: 'No tables found',
    filters: {
      createdDate: 'Created Date',
      updatedDate: 'Updated Date',
      searchButton: 'Search',
      filterStart: 'Filter Start',
      filterEnd: 'Filter End',
      toggleIncludeDeleted: 'Include Deleted'
    }
  },

  // Accommodation Bookings
  accommodationBookings: {
    title: 'Accommodation Bookings',
    loading: 'Loading...',
    noBookingsFound: 'No accommodation bookings found',
    filters: {
      checkinDate: 'Check-in Date',
      checkoutDate: 'Check-out Date',
      status: 'Status',
      allStatus: 'All Status',
      searchButton: 'Search',
      filterStart: 'Start Date',
      filterEnd: 'End Date'
    },
    status: {
      confirmed: 'Confirmed',
      cancelled: 'Cancelled',
      pending: 'Pending'
    },
    table: {
      id: 'ID',
      hotelName: 'Hotel Name',
      checkinDate: 'Check-in Date',
      checkoutDate: 'Check-out Date',
      guestCount: 'Guest Count',
      hasMeal: 'Has Meal',
      hasEventGuests: 'Event Guests',
      totalPrice: 'Total Price',
      status: 'Status',
      createdAt: 'Created At'
    },
    csvExport: {
      button: 'CSV Export',
      title: 'CSV Export',
      message: 'Export {count} records to CSV.',
      encodingLabel: 'Character Encoding',
      cancel: 'Cancel',
      export: 'Export',
      exporting: 'Exporting...'
    }
  },

  // Postal Codes
  postalCodes: {
    title: 'Postal Code Master',
    csvImport: 'CSV Import',
    importing: 'Importing...',
    importComplete: 'Import Complete',
    importCount: 'Imported: {count} records',
    errors: 'Errors:',
    moreErrors: '...and {count} more',
    table: {
      postalCode: 'Postal Code',
      prefecture: 'Prefecture',
      city: 'City',
      area: 'Area',
      prefectureKana: 'Prefecture (Kana)',
      cityKana: 'City (Kana)',
      areaKana: 'Area (Kana)'
    },
    importModal: {
      title: 'CSV File Import',
      fileLabel: 'Please select a CSV file',
      fileHelp: 'Upload the ken_all.csv file from Japan Post (Shift-JIS encoded).',
      cancel: 'Cancel',
      import: 'Import'
    }
  },

  // Import
  import: {
    ledghome: {
      title: 'Import > Donator Information',
      description: 'You can import CSV file "寄附者情報" that is exported from LedgHome',
      dropMessage: 'Click here to select files or\ndrag and drop files',
      importButton: 'Import',
      importing: 'Importing...',
      maxFilesError: 'You can upload up to {max} files',
      importError: 'Import failed',
      results: {
        title: 'Import Results',
        titleSuccess: 'Import Completed',
        titleWithErrors: 'Import Completed with errors',
        totalFiles: 'Total Files',
        processedFiles: 'Processed Files',
        totalRows: 'Total Rows',
        createdDonators: 'Created Donators',
        updatedDonators: 'Updated Donators',
        createdStockholders: 'Created Stockholders',
        updatedStockholders: 'Updated Stockholders',
        deletedStockholders: 'Deleted Stockholders',
        errors: 'Errors'
      }
    },
    messages: {
      data_provider_not_found: 'Data provider not found',
      import_completed: 'Import completed',
      import_failed: 'Import failed',
      donator_number_required: 'Donator number is required'
    },
    validation: {
      files_required: 'Please select files',
      files_array: 'Files must be an array',
      files_max: 'You can upload up to 10 files',
      file_required: 'File is required',
      file_type: 'Invalid file type',
      file_mimes: 'Only CSV files (.csv, .txt) can be uploaded',
      file_size_max: 'File size must be less than 50MB'
    }
  },

  // Events
  events: {
    titleList: 'Scheduled Events',
    helpTooltip: 'Displaying events scheduled for the selected period',
    eventName: 'Event Name',
    capacity: 'Capacity',
    isOnline: 'Online',
    organizer: 'Organizer',
    eventDate: 'Date',
    fee: 'Fee',
    noData: 'No data available',
    loading: 'Loading...',
    additionalOrganizers: '+{count} more',
  },

  // Event Organizers
  eventOrganizers: {
    title: 'Event Organizers',
    titleList: 'Master Data',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    searchPlaceholder: 'Search by organizer name...',
    addNew: 'Add New',
    organizer: 'Organizer',
    organizerName: 'Organizer Name',
    phoneMain: 'Phone (Main)',
    phoneSub: 'Phone (Sub)',
    emailMain: 'Email (Main)',
    emailSub: 'Email (Sub)',
    address: 'Address',
    postalCode: 'Postal Code',
    postalCodePlaceholder: '888-8888',
    prefecture: 'Prefecture',
    prefectureDefault: 'Please select',
    city: 'City',
    cityPlaceholder: 'Kamikawa-gun Higashikawa-cho',
    cityDetail: 'Address Detail',
    cityDetailPlaceholder: '1-1-1',
    building: 'Building',
    buildingPlaceholder: 'Sentopure',
    delete: 'Delete',
    cancel: 'Cancel',
    update: 'Update',
    noData: 'No data available',
    loading: 'Loading...',
    required: 'Required',
    confirmDelete: 'Are you sure you want to delete? This action cannot be undone.',
    errorFetchData: 'Failed to fetch data',
    successUpdate: 'Event organizer updated successfully',
    successCreate: 'Event organizer created successfully',
    errorSave: 'Failed to save',
    successDelete: 'Event organizer deleted successfully',
    errorDelete: 'Failed to delete',
    errorDeleteInUse: 'This event organizer is already used in events and cannot be deleted. Please remove the organizer from events first.',
    validation: {
      nameRequired: 'Please enter organizer name',
      nameMaxLength: 'Organizer name must be 255 characters or less',
      phoneInvalid: 'Phone number must contain only digits and hyphens (-)',
      phoneMaxLength: 'Phone number must be 20 characters or less',
      emailInvalid: 'Please enter a valid email address',
      emailMaxLength: 'Email address must be 255 characters or less',
      postalCodeRequired: 'Please enter postal code',
      postalCodeInvalid: 'Postal code must be in format 999-9999',
      postalCodeMaxLength: 'Postal code must be 10 characters or less',
      prefectureRequired: 'Please select prefecture',
      cityRequired: 'Please enter city',
      cityMaxLength: 'City must be 100 characters or less',
      townMaxLength: 'Address detail must be 100 characters or less',
      buildingMaxLength: 'Building name must be 200 characters or less'
    },
    messages: {
      fetchFailed: 'Failed to fetch data',
      updated: 'Event organizer updated successfully',
      created: 'Event organizer created successfully',
      saveFailed: 'Failed to save',
      deleted: 'Event organizer deleted successfully',
      deleteFailed: 'Failed to delete'
    }
  },

  // Master Events
  masterEvents: {
    title: 'Events',
    titleList: 'Master Data',
    searchPlaceholder: 'Search by event name...',
    addNew: 'Add New',
    eventName: 'Event Name',
    description: 'Description',
    startDate: 'Start Date',
    endDate: 'End Date',
    capacity: 'Capacity',
    forecastedVisitorCount: 'Forecasted Visitor Count',
    isOnline: 'Online',
    organizer: 'Organizer',
    feeMax: 'Fee (Max)',
    feeMin: 'Fee (Min)',
    noData: 'No data available',
    loading: 'Loading...',
    // Form
    edit: 'Edit',
    create: 'Create',
    createButton: 'Create',
    update: 'Update',
    cancel: 'Cancel',
    delete: 'Delete',
    confirmDelete: 'Are you sure you want to delete? This action cannot be undone.',
    // Organizers section
    organizers: 'Event Organizers',
    selectOrganizer: 'Select organizer',
    isPrimary: 'Primary organizer',
    addOrganizer: 'Add organizer',
    // Fees section
    fees: 'Fees',
    feeType: 'Type',
    feeAmount: 'Amount',
    feeDescription: 'Description',
    addFee: 'Add fee',
    // Messages
    errorFetchData: 'Failed to fetch data',
    successCreate: 'Event created successfully',
    successUpdate: 'Event updated successfully',
    successDelete: 'Event deleted successfully',
    errorSave: 'Failed to save',
    errorDelete: 'Failed to delete',
    errorDeleteInUse: 'This event cannot be deleted because it has booking data associated with it.',
    // Image upload section
    addImage: 'Add Image',
    imageCountHint: 'Up to 5 images',
    analyzing: 'Analyzing with AI...',
    analyzeWithAI: 'Analyze with AI',
    // Event form
    eventNumber: 'Event {n}',
    organizerTooltip: 'Select an organizer registered in the event organizer master',
    searchOrganizer: 'Search organizer...',
    dateRange: 'Event Period',
    currencyYen: '¥{amount}',
    capacityWithHint: 'Capacity',
    capacityUnit: 'people',
    forecastedVisitorCount: 'Forecasted Visitor Count',
    onlineEvent: 'Online Event',
    deleteEvent: 'Delete Event',
    addEventInput: 'Add Event Form',
    participationFee: 'Participation Fee',
    // Messages
    analyzeSuccess: 'Event flyer analysis completed',
    successCreateBulk: '{count} events have been created',
    errorNoFilesToAnalyze: 'No images to analyze',
    errorAnalyze: 'Failed to analyze event flyer',
    // Validation
    validation: {
      titleRequired: 'Please enter an event name',
      titleMaxLength: 'Event name must be 255 characters or less',
      startDateRequired: 'Please enter a start date',
      endDateRequired: 'Please enter an end date',
      endDateAfterStart: 'End date must be on or after the start date',
      organizerRequired: 'Please add at least one organizer',
      organizerSelectRequired: 'Please select an organizer',
      feeTypeRequired: 'Please enter a fee type',
      feeAmountRequired: 'Please enter an amount',
      organizerDuplicate: 'The same organizer is selected multiple times',
      feeTypeDuplicate: 'The same fee type is set multiple times',
      forecastedVisitorCountRequired: 'Forecasted visitor count is required when capacity is not entered'
    }
  },

  // Export
  export: {
    statisticData: {
      title: 'Export > Statistics',
      description: 'You can export various statistical data generated by this service',
      periodLabel: 'Aggregation Period',
      dataTypeLabel: 'Data Type',
      dataTypes: {
        statistic_summaries: 'Overall Statistics',
        statistic_visitor_attributes: 'Visitor Attributes',
        statistic_visitor_accommodation_bookings: 'Accommodation Statistics',
        statistic_visitor_event_bookings: 'Event Statistics'
      },
      encodingLabel: 'Output Data Format',
      encodings: {
        sjis: 'Shift-JIS',
        utf8: 'UTF-8'
      },
      exportButton: 'Export',
      exporting: 'Exporting...',
      errors: {
        select_data_type: 'Please select a data type',
        select_encoding: 'Please select an output data format',
        max_days: 'Please specify a period within 100 days',
        invalid_date_range: 'End date must be later than start date',
        no_permission: 'You do not have CSV operation permission',
        export_failed: 'CSV export failed',
        invalid_data: 'Input data is not correct'
      },
      warnings: {
        not_implemented: 'Cannot export as it is currently under implementation',
      },
      tooltips: {
        dateRange: 'Used to filter by the reference date of statistics created daily. You can select up to 100 days within the period of the generated statistical data.',
        encodingType: 'As a general rule, Windows users should use Shift-JIS, and MacOS users should use UTF-8. If characters are garbled, please check the encoding settings of the application you are using in your environment.',
      }
    }
  }
};
